/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2024 (original work) Open Assessment Technologies SA;
 */

/**
 * Chains the guards to be used in the routing configuration: each guard gets the rest of the chain
 * as its `next`, the last one the controller, so guard error handling covers it too (SOLAR-1981).
 * @param {Array<Function>} guards The guards to combine
 * @returns {Promise}
 */
export const multiGuard =
    (guards = []) =>
    (next, router) =>
        guards.reduceRight((chainedNext, guard) => () => guard(chainedNext, router), next)();
